import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TVotePostPollSucceed, EVotePostPollActionType, IVotePostPollSucceedParams } from './types';

export const votePostPollSucceed: (data: IVotePostPollSucceedParams) => TVotePostPollSucceed = actionGenerator<
  EVotePostPollActionType.Succeed,
  IVotePostPollSucceedParams
>(EVotePostPollActionType.Succeed);
